import styled from 'styled-components';

export const StyledEnvironmentCard = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 0px #00000026;
  padding: 12px;
  border-radius: 10px;
`;

